import React, { useState } from "react"
import "./Eratek1KBNavbar.css"
import { NavLink } from "react-router-dom"
import { useExternalMedia } from "../../../../hooks/useExternalMedia";
import { useExport } from "../../../../hooks/useExport";
import ButtonComponent from "../../../../utils/button/ButtonComponent";
import { Colors } from "../../../../utils/colors/colors";
import { useModal } from "../../../../hooks/utils.hook";
import { MediumModal } from "../../../../utils/modals/Modal";
import OneKBInitiativeIntakeForm from "../../../../components/modal-contents/OneKBInitiativeIntakeForm";
import { HOME } from "../../../../routes/paths.routes";
import { NavHashLink } from "react-router-hash-link";




const Eratek1KBNavbar = () => {


  const [showNavbar, setShowNavbar] = useState(false);


  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const {
    eratekLogoColored
  } = useExternalMedia();

  const {
    navIcon
  } = useExport();


  const {
    secondaryColor,
    whiteColor
  } = Colors();



  const {
    open,
    openModal,
    closeModal
  } = useModal();



  return (
    <>
      <nav
        id="navbar" className="section navbar"
      >
        <div className="container navbar-container">

          <div className="logo">
            <NavLink to={`/${HOME}`}>
              <img src={eratekLogoColored} alt="Eratek logo" />
            </NavLink>
          </div>

          <div className="menu-icon" onClick={handleShowNavbar}>
            <img src={navIcon} alt="menu" />
          </div>


          <div className={`nav-elements  ${showNavbar && "active"}`}>
            <ul>
              <li>
                <NavLink to={`/${HOME}`} onClick={handleShowNavbar}>Home</NavLink>
              </li>
              <li>
                <NavHashLink to="#about" activeClassName="active" onClick={handleShowNavbar}
                  scroll={(el: any) => el.scrollIntoView({ behavior: "smooth", block: "start" })}
                >About</NavHashLink>
              </li>
              <li>
                <NavHashLink to="#benefits" activeClassName="active" onClick={handleShowNavbar}
                  scroll={(el: any) => el.scrollIntoView({ behavior: "smooth", block: "start" })}
                >Benefits</NavHashLink>
              </li>
              <li>
                <NavHashLink to="#faqs" activeClassName="active" onClick={handleShowNavbar}
                  scroll={(el: any) => el.scrollIntoView({ behavior: "smooth", block: "start" })}
                >FAQs</NavHashLink>
              </li>
            </ul>
          </div>


          <ButtonComponent
            bgColor={secondaryColor}
            text={"Get Started For Free"}
            click={openModal}
            isLoading={false}
            style={{
              color: whiteColor,
              maxWidth: "230px",
            }}
            data-aos="fade-up"
            data-aos-once="true"
            cName="get-started-btn"
          />

        </div>
      </nav>




      <MediumModal
        open={open}
        showCloseIcon={false}
        openModal={openModal}
        closeModal={closeModal}
        children={<OneKBInitiativeIntakeForm
          closeModal={closeModal}
        />
        }
      />
    </>
  );



};

export default Eratek1KBNavbar;